import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'unsaved-changes-dialog',
    templateUrl: './unsaved-changes-dialog.html'
})
export class UnsavedChangesDialog implements OnInit {
    constructor(
        public activeModal: NgbActiveModal
    ) {}

    ngOnInit() {}
}